module.exports = window.XMLHttpRequest;



//////////////////
// WEBPACK FOOTER
// ./~/httpplease/lib/xhr-browser.js
// module id = 815
// module chunks = 4